var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z","fill":"#dc458b","key":0}),React.createElement("g",{"id":"hide","transform":"translate(-.5 -.5)","key":1},React.createElement("path",{"d":"m15 7h-1a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1z","fill":"#fff"})),React.createElement("g",{"transform":"rotate(90,14.5,14)","key":2},React.createElement("path",{"d":"m14 22h1a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1z","fill":"#fff"}))]);
}

PlusInline.defaultProps = {"width":"28","height":"28","version":"1.1","viewBox":"0 0 28 28"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
